export default function sanitizeAndCombineUrl(redirectUrl: string, search: string): string {
  if (!search) {
    // if the search string is empty or null, just return the redirectUrl
    return redirectUrl;
  }
  if (!redirectUrl.includes('?')) {
    // if the redirectUrl doesn't have a ?, just concatenate them
    return redirectUrl + search;
  }
  // if the redirectUrl already has a ?, replace the ? in search with an &
  return redirectUrl + search.replace('?', '&');
}
